import { render, staticRenderFns } from "./ComentariosReferencias.vue?vue&type=template&id=7f3cf090&"
import script from "./ComentariosReferencias.vue?vue&type=script&lang=js&"
export * from "./ComentariosReferencias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports